import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaArrowLeft,
    FaChevronRight,
    FaExternalLinkAlt,
    FaFileAlt,
    FaGraduationCap,
    FaLinkedinIn,
    FaPlay,
} from 'react-icons/fa';
import styles from './pagina_nutri_marimurra.module.scss';

const PERFIS = [
    {
        titulo: 'Currículo Lattes',
        descricao: 'Formação, pesquisas e produção científica',
        href: 'http://lattes.cnpq.br/2879894502401030',
        icon: <FaGraduationCap />,
    },
    {
        titulo: 'LinkedIn',
        descricao: 'Trajetória profissional',
        href: 'https://www.linkedin.com/in/mariana-murra-a61a012b4',
        icon: <FaLinkedinIn />,
    },
];

const ARTIGOS = ['34994205', '37526408', '40917097', '42540666', '42298014'];

type Video = {
    id: string;
    tipo: string;
    titulo: string;
    inicio?: number;
};

const VIDEOS: Video[] = [
    { id: 'TU5ikEt30jc', tipo: 'Entrevista', titulo: 'Entrevista com Mariana Murra' },
    { id: 'aMC2RoDU5NY', tipo: 'Podcast', titulo: 'Podcast com Mariana Murra', inicio: 2832 },
];

const VideoCard: React.FC<{ video: Video }> = ({ video }) => {
    const [tocando, setTocando] = useState(false);
    const inicio = video.inicio ? `&start=${video.inicio}` : '';
    const youtubeUrl = `https://www.youtube.com/watch?v=${video.id}${video.inicio ? `&t=${video.inicio}s` : ''}`;

    return (
        <figure className={styles.video}>
            <div className={styles.videoFrame}>
                {tocando ? (
                    <iframe
                        src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0${inicio}`}
                        title={video.titulo}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                ) : (
                    <button
                        type="button"
                        className={styles.videoCover}
                        onClick={() => setTocando(true)}
                        aria-label={`Assistir: ${video.titulo}`}
                    >
                        <img
                            src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
                            alt=""
                            loading="lazy"
                        />
                        <span className={styles.videoTag}>{video.tipo}</span>
                        <span className={styles.playButton}>
                            <FaPlay />
                        </span>
                    </button>
                )}
            </div>
            <figcaption className={styles.videoCaption}>
                <span className={styles.videoTitle}>{video.titulo}</span>
                <a href={youtubeUrl} className={styles.videoLink} target="_blank" rel="noopener noreferrer">
                    YouTube <FaExternalLinkAlt aria-hidden />
                </a>
            </figcaption>
        </figure>
    );
};

const Conteudos_nutri_marimurra: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pagina_nutri_marimurra}>
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/nutri_marimurra" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <p className={styles.eyebrow}>Ciência na prática</p>
                <h1 className={styles.title}>Conteúdos</h1>
                <p className={styles.lead}>
                    Pesquisadora e mestre em oncologia. Aqui você encontra minha trajetória acadêmica, artigos
                    publicados e participações em entrevistas e podcasts.
                </p>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>01</span>
                    <h2 className={styles.sectionTitle}>Entrevistas e podcasts</h2>
                    <div className={styles.videos}>
                        {VIDEOS.map((video) => (
                            <VideoCard key={video.id} video={video} />
                        ))}
                    </div>
                </div>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>02</span>
                    <h2 className={styles.sectionTitle}>Artigos publicados</h2>
                    <div className={styles.linkList}>
                        {ARTIGOS.map((pmid, index) => (
                            <a
                                key={pmid}
                                href={`https://pubmed.ncbi.nlm.nih.gov/${pmid}/`}
                                className={styles.linkRow}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.itemIcon}>
                                    <FaFileAlt />
                                </span>
                                <span className={styles.linkRowText}>
                                    <span className={styles.linkRowTitle}>Artigo {index + 1}</span>
                                    <span className={styles.linkRowDesc}>PubMed · PMID {pmid}</span>
                                </span>
                                <FaChevronRight className={styles.linkRowArrow} />
                            </a>
                        ))}
                    </div>
                </div>

                <div className={styles.section}>
                    <span className={styles.sectionNumber}>03</span>
                    <h2 className={styles.sectionTitle}>Currículo</h2>
                    <div className={styles.linkList}>
                        {PERFIS.map((perfil) => (
                            <a
                                key={perfil.titulo}
                                href={perfil.href}
                                className={styles.linkRow}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.itemIcon}>{perfil.icon}</span>
                                <span className={styles.linkRowText}>
                                    <span className={styles.linkRowTitle}>{perfil.titulo}</span>
                                    <span className={styles.linkRowDesc}>{perfil.descricao}</span>
                                </span>
                                <FaChevronRight className={styles.linkRowArrow} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Conteudos_nutri_marimurra;
